import React, { useEffect, useState } from "react";
import { transformResultsToTableData } from "../../../../services/commonService";
import InsightTable from "../InsightTable";

function ExecutiveTeamAndKeyLeadership({ executiveTeamAndKeyLeadership }) {
  const [tabData, setTabData] = useState([]);

  const actions = [
    // { type: "chart", title: "Chart", onClick: () => {} },
    { type: "conversation", title: "Conversation", onClick: () => {} },
    { type: "mindMap", title: "Mind Map", onClick: () => {} },
    { type: "download", title: "Download", onClick: () => {} },
  ];

  // const dummyData = [
  //   {
  //     competitor: "a",
  //     ceo: "b",
  //     cfo: "c",
  //     key_leadership_experties: "d",
  //     key_leadership_focus: "e",
  //     key_leadership_changes: "f",
  //     ceo_positive_insight: "b",
  //     ceo_negative_insight: "b",
  //     ceo_recent_development: "b",
  //     cfo_positive_insight: "c",
  //     cfo_negative_insight: "c",
  //     cfo_recent_development: "c",
  //     key_leadership_experties_positive_insight: "d",
  //     key_leadership_experties_negative_insight: "d",
  //     key_leadership_experties_recent_development: "d",
  //     key_leadership_focus_positive_insight: "e",
  //     key_leadership_focus_negative_insight: "e",
  //     key_leadership_focus_recent_development: "e",
  //     key_leadership_changes_positive_insight: "f",
  //     key_leadership_changes_negative_insight: "f",
  //     key_leadership_changes_recent_development: "f",
  //   },
  //   {
  //     competitor: "a",
  //     ceo: "b",
  //     cfo: "c",
  //     key_leadership_experties: "d",
  //     key_leadership_focus: "e",
  //     key_leadership_changes: "f",
  //     ceo_positive_insight: "b",
  //     ceo_negative_insight: "b",
  //     ceo_recent_development: "b",
  //     cfo_positive_insight: "c",
  //     cfo_negative_insight: "c",
  //     cfo_recent_development: "c",
  //     key_leadership_experties_positive_insight: "d",
  //     key_leadership_experties_negative_insight: "d",
  //     key_leadership_experties_recent_development: "d",
  //     key_leadership_focus_positive_insight: "e",
  //     key_leadership_focus_negative_insight: "e",
  //     key_leadership_focus_recent_development: "e",
  //     key_leadership_changes_positive_insight: "f",
  //     key_leadership_changes_negative_insight: "f",
  //     key_leadership_changes_recent_development: "f",
  //   },
  // ];
  useEffect(() => {
    const tableData = transformResultsToTableData(
      executiveTeamAndKeyLeadership
    );
    setTabData(tableData);
  }, [executiveTeamAndKeyLeadership]);

  const tableColumns = [
    { key: "ceo", label: "CEO" },
    { key: "cfo", label: "CFO" },
    { key: "key_leadership_expertise", label: "Key Leadership Experties" },
    { key: "key_leadership_focus", label: "Key Leadership Focus" },
    { key: "key_leadership_changes", label: "Key Leadership Changes" },
  ];

  return (
    <InsightTable
      title="Executive Team & Key Leadership"
      data={tabData}
      metrics={tableColumns}
      rowIdentifier="competitor"
      actions={actions}
    />
  );
}

export default ExecutiveTeamAndKeyLeadership;
